<div class="wrapper">
    <!-- Sidebar  -->
    <nav [ngClass]="{ 'active': showSideBar }" id="sidebar">
        <div class="sidebar-bg">
            <div class="sidebar-toggle">
        <span (click)="toggleSidebar()" id="sidebar-toggle-btn">
          @if (!isSidebarClosed) {
              <i class="fa fa-chevron-left fa-2x"></i>
          } @else {
              <i class="fa fa-chevron-right fa-2x"></i>
          }
        </span>
            </div>

            <div class="sidebar-scroll-container">

                <div class="logo-box">
                    <div [hidden]="!getLogoImage()" class="merchant-logo">
                        <img [ngSrc]="getLogoImage()" alt="Logo" height="100%" width="100%">
                    </div>
                </div>

                <div [class]="getInstanceLogoPaddingClass">
                    <div class="instance-logo-container">
                        <a [routerLink]="routes.SECURE.HOME.VIEW.path">
                            <img [ngSrc]="logoMain | assetSource" alt="Logo" height="100%" width="100%"/>
                        </a>
                    </div>
                </div>

                <ul class="list-unstyled components">
                    @for (item of items; track $index) {
                        <li (externalClick)="onExternal($event)"
                            (groupToggle)="toggleGroup($event)"
                            (linkClick)="clearFilters()"
                            [item]="item"
                            [openGroupKey]="openGroupKey"
                            [signUpFeePaid]="isSignUpFeePaid"
                            app-menu-item></li>
                    }
                    <br>
                    <li>
                        <strong>Merchant ID - </strong>{{ getMerchantPrefix }}
                    </li>
                    @if (getExternalIdentifier) {
                        <li>
                            <strong>External Identifier - </strong>{{ getExternalIdentifier }}
                        </li>
                    }
                </ul>
            </div>
        </div>
    </nav>

    <!-- Page Content  -->
    <div [ngClass]="{ 'active': isSidebarClosed }" id="content">
        <div [hidden]="hideSubscriptionBanner"
             class="subscription-banner {{isGracePeriodExpired ? 'badge-danger':'badge-warning'}}">
            {{ isGracePeriodExpired ? 'Your subscription has been BLOCKED.' : '' }}Please pay your subscription fee.
            @if (isAdminUser()) {
                <span>
        Click
        <a [routerLink]="routes.SECURE.PURCHASE.MESSAGE_BUNDLES.path" class="pay-subscription-link"> here </a>
        to pay
      </span>
            }
        </div>

        <div [ngClass]="{'container': pageHeaderCentered, 'header-container': true}">
            <div class="sign-in-information-container">
      <span class="sm">
        <h4>{{ getUserName() }} signed in for:</h4>
      </span>
                <div class="business-dropdown">
                    <p-select (onChange)="switchMerchant()"
                              [(ngModel)]="selectedBusinessId"
                              [filter]="true"
                              [options]="businessList"
                              [showClear]="false"
                              class="business-dropdown w-full"
                              optionDisabled="disabled"
                              optionLabel="displayName"
                              optionValue="businessId"
                              styleClass="ui-dropdown"></p-select>
                </div>
            </div>
            <div [ngClass]="{'pl-2': !pageHeaderCentered, 'page-header card-header': true}">
                <h1>{{ pageHeaderText }}@if (pageHeaderTooltipText) {
                    <i class="pi pi-question-circle header-tooltip"
                       pTooltip="{{pageHeaderTooltipText}}"
                       tooltipPosition="bottom"></i>
                }
                </h1>
                @if (contentHeaderLogo) {
                    <img [alt]="contentHeaderLogo.alt"
                         [height]="contentHeaderLogo.height"
                         [ngSrc]="contentHeaderLogo.asset | assetSource"
                         [width]="contentHeaderLogo.width"
                         class="content-header-logo content-header-logo-right"/>
                }
            </div>
        </div>

        <app-alert></app-alert>
        <router-outlet></router-outlet>
    </div>
</div>
